// A banner's GTM name, shared by its view_promotion impression and its TrackedButtonClick so the
// two can be joined on one string: the banner id, then the heading with every space dashed. A
// banner with no heading is named by its id alone.
export default function bannerName<Id extends string>(
  id: Id,
  heading?: string
): Id | `${Id}_${string}` {
  const label = heading?.trim().replace(/\s+/g, '-');

  return label ? `${id}_${label}` : id;
}
